import { render, staticRenderFns } from "./AbonosComponent.vue?vue&type=template&id=894887a2&scoped=true"
import script from "./AbonosComponent.vue?vue&type=script&lang=js"
export * from "./AbonosComponent.vue?vue&type=script&lang=js"
import style0 from "./AbonosComponent.vue?vue&type=style&index=0&id=894887a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894887a2",
  null
  
)

export default component.exports